/* global window */
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { update } from "../../../state/bordersSlice";
import { makeStyles } from "@fluentui/react-components";
import { openStyleSheetDialog } from "../../../state/appStateSlice";
import TrackedButton from "../../common/TrackedButton";

const useClasses = makeStyles({
  Header: {
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700,
    lineGeight: 11.5,
    textAlign: "left",
  },
  PanelButton: {
    justifyContent: "left",
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 400,
    letterSpacing: "0.02em",
  },
  AccordionHeader: {
    "& > button": {
      minHeight: 0,
    },
  },
});

const buttonStyles = {
  selected: { backgroundColor: "#F5F5F5" },
  unselected: { backgroundColor: "transparent" },
};

const BorderPresetMenuItem = () => {
  const classes = useClasses();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selection = useSelector((state) => state.selection.borders[0]);
  const currentStyleSheet = useSelector(
    (state) => state.styleSheet.sheets[state.styleSheet.selectedSheet] ?? state.styleSheet.sheets["default"]
  );
  const selectedBorder = useSelector((state) => state.gridd.present.borders.find((b) => b.id === selection.id));

  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
        {currentStyleSheet.borders?.map((border, index) => (
          <React.Fragment key={border.name}>
            <TrackedButton
              id={`level_${index}_border_button`}
              appearance="subtle"
              style={selectedBorder.preset === border.name ? buttonStyles.selected : buttonStyles.unselected}
              className={classes.PresetButton}
              onClick={() => {
                dispatch(
                  update({
                    id: selectedBorder.id,
                    color: currentStyleSheet.colors.find((c) => c.name === border.color)?.value ?? "black",
                    weight: border.width,
                    style: border.type,
                    preset: border.name,
                  })
                );
              }}
            >
              <div
                style={{
                  borderBottomColor: currentStyleSheet.colors.find((c) => c.name === border.color)?.value ?? "black",
                  borderBottomWidth: border.width,
                  borderBottomStyle: border.type,
                }}
              >
                {t("menu.style.borders." + border.name)}
              </div>
            </TrackedButton>
          </React.Fragment>
        ))}
      </div>
      <div style={{ marginTop: 8, textAlign: "center" }}>
        <a
          href="#"
          style={{
            color: "#0065FD",
            textDecoration: "none",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onClick={(e) => {
            e.preventDefault();
            dispatch(openStyleSheetDialog());
            window.setTimeout(() => {
              const tab = window.document.getElementById("borders");
              if (tab) tab.click();
            }, 100);
          }}
        >
          {t("menu.stylesheet.editPresetStyles")}
        </a>
      </div>
    </div>
  );
};

export default BorderPresetMenuItem;
